<template>
  <el-dialog
    :title="$i18.language('选择市场研究报告')"
    :visible.sync="dialogVisible"
    class="country-dialog el-body-contry-dialog"
    :append-to-body="false"
    @closed="handleClose">
    <div class="report-wrap">
    <div class="sjcright endte">
      <p class="label">{{ $i18.language('行业分类') }}</p>
      <el-select class="margin5" popper-class="customer-select select-zindex" v-model="searchForm.industry" @change="changeFilters" clearable :placeholder="$i18.language('筛选')">
        <el-option v-for="item in typeOptionsIndustry" :key="item.value" :label="item.label" :value="item.value"> </el-option>
      </el-select>
      <p class="label">{{ $i18.language('报告类型') }}</p>
      <el-select class="margin5" popper-class="customer-select select-zindex" v-model="searchForm.label" @change="changeFilters" clearable :placeholder="$i18.language('筛选')">
        <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
      </el-select>
      <el-input :placeholder="$i18.language('输入关键词进行搜索')" :maxlength="100" v-model="searchForm.keyword" class="margin10 input-with-select" @keyup.enter.native="changeFilters">
        <svg-icon @click.native="changeFilter" name="search" slot="suffix" style="height: 100%"></svg-icon>
      </el-input>
      <!-- <el-radio-group class="lang-radio" size="mini" v-model="searchForm.reportLanguage" @change="changeLanguage">
        <el-radio-button label="en">{{ $t('english') }}</el-radio-button>
        <el-radio-button label="zh">{{ $t('chinese') }}</el-radio-button>
      </el-radio-group> -->
    </div>
    <div class="analysis-list" v-loading="loading">
      <div v-for="item in reportList.result" :key="item.id" class="item-panel">
        <div class="contentCreate-box show-back" @click="handleDetail(item)" :style="{'background':'url('+(item.thumb ? item.thumb : defaultImg )+')'+' '+'center'}">
          <div class="contentList-text">
            <span class="title">{{ item.title }}</span>
          </div>
        </div>
        <div class="content">
          <div class="mg12 content-title">
            <span @click="handleDetail(item)">{{item.title}}
              <svg-icon v-show="!!item.open" class="img-svg" :name="reportLanguage=='en'?'yikaitong-en':'yikaitong'"></svg-icon>
              <svg-icon v-show="!!item.isSample" class="img-svg" :name="reportLanguage=='en'?'yangben-en':'yangben'"></svg-icon>
            </span>
            <el-button @click="handleDetail(item)" class="confirm-btn">{{$i18.language("选择该报告")}}</el-button>
          </div>
          <div class="mg12 content-tag">
            <span v-for="(el, index) in item.label" :class="labelClassName(el)" :key="index">{{el}}</span>
          </div>
          <div class="mg12 content-text">
            <span v-html="item.description"></span>
          </div>
          <div class="bottom-info">
            <span class="bottom-info-item"> <svg-icon name="time"></svg-icon> {{$i18.language("发表时间")}}：{{item.time}}</span>
            <span class="bottom-info-item">
              <svg-icon name="folder"></svg-icon> {{$i18.language("下载")}}：<span v-for="(el, index) in item.files" @click="download(el)" :key="index" class="download"><span>{{el.type===0?'PDF':'PPT'}}</span><span v-show="(index+1)<item.files.length">、</span></span>
            </span>
            <span class="bottom-info-item"><svg-icon name="file"></svg-icon> {{$i18.language("页数")}}：{{item.page}}</span>
          </div>
        </div>
      </div>
      <empty v-if="!reportList.result.length" class="empty-table"></empty>
    </div>
    <table-footer class="table-pages" :showSearch="false" :pageIndex="searchForm.pageIndex" :pageSize="searchForm.pageSize" :showPageSize="false" :total="total" @change-page="changePage"></table-footer>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="sub-confirm-btn" @click="handleClose">{{$i18.language("取消")}}</el-button>
      <el-button class="confirm-btn" type="primary" @click="handleClose">{{$i18.language("确定")}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import empty from '@/components/empty.vue'
import tableFooter from '@/components/tableFooter'

export default {
  components: {
    empty,
    tableFooter
  },
  props: {

  },
  data() {
    return {
      dialogVisible: false,
      searchForm: {
        industry: '',
        label: '',
        keyword: '',
        pageIndex: 1,
        pageSize: 10,
      },
      defaultImg: require('@/assets/analysis/bg.png'),
      typeOptionsIndustry: [],
      typeOptions: [],
      reportList: {
        result: []
      },
      loading: false,
      total: 0,
      reportLanguage: localStorage.getItem("language"),
      labels: [
        {zh: "行业与市场", value: "trade", en: "Industry & Market"},
        {zh: "国家与地区", value: "country", en: "Country & Region"},
        {zh: "公司与产品", value: "company", en: "Companies & Products"},
        {zh: "消费与品牌", value: "brand", en: "Consumer & Brand"},
        {zh: "数字与趋势", value: "trend", en: "Digital & Trend"},
      ],
    };
  },
  methods: {
    open() {
      this.getLabels()
      this.getIndustrys()
      this.changeFilter()
      this.dialogVisible = true
    },
    changePage(val) {
      this.searchForm.pageIndex = val
      this.changeFilter()
    },
    handleClose() {
      this.searchForm = {
        industry: '',
        label: '',
        keyword: '',
        pageIndex: 1,
        pageSize: 10,
      }
      this.reportList = {
        result: []
      }
      this.loading = false
      this.dialogVisible = false
    },
    download() {},
    // 获取标签颜色
    labelClassName(val) {
      let obj = this.labels.find(item=>item.zh == val)
      return obj?obj.value:""
    },
    handleDetail(row) {
      let {id, title} = row
      if (this.reportLanguage == 'zh') {
        this.$emit('selectReport', row)
      } else {
        this.$emit('selectReport', { id: row.relevanceId, title: row.relevanceTitle, en_title: row.title, difyId: row.difyId });
      }
      this.handleClose()
    },
    changeFilters() {
      this.searchForm.pageIndex = 1
      this.changeFilter()
    },
    changeFilter() {
      this.loading = true
      let params = {
        ai: true,
        searchType: 0,
        reportLanguage: this.reportLanguage,
        ...this.searchForm
      }
      this.$api.analysis.getPageList(params).then(res => {
        this.total = res.data.totalCount
        this.reportList = res.data.data
        this.loading = false
      }).finally(res=>this.loading = false)
    },
    //获取行业分类
    getIndustrys() {
      this.$api.analysis.getIndustrys({ reportLanguage: this.reportLanguage }).then((res) => {
        this.typeOptionsIndustry = res.data
      })
    },
    // 获取报告类型
    getLabels() {
      this.$api.analysis.getLabels({ reportLanguage: this.reportLanguage }).then((res) => {
        this.typeOptions = res.data
      })
    },
  },
};
</script>

<style scoped lang="scss">
.zIndex {
  z-index: 10002 !important;
}
.report-wrap {
  max-height: 550px;
  .sjcright {
    display: flex;
    align-items: center;
    // width: 70%;
    flex: 1;
    justify-content: flex-end;
    p {
      font-weight: normal;
      color: $--color-font-light;
      text-wrap: nowrap;
    }
    .label {
      text-align: right;
      margin: 0 10px;
      &:first-child {
        margin-left: 0;
      }
    }
    .margin5 {
      &:first-of-type {
        min-width: 210px;
      }
      min-width: 120px;
      max-width: 260px;
    }
    .margin10 {
      margin-left: 10px;
    }
    /deep/ .el-input__inner {
      padding: 0 10px;
      padding-right: 30px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
  .analysis-list {
    padding: 20px 37px;
    .item-panel {
      display: flex;
      margin-bottom: 50px;
      .contentCreate-box {
        cursor: pointer;
        background-color: #ffffff;
        padding: 6px 8px;
        height: 204px;
        min-width: 145px;
        max-width: 145px;
        overflow: hidden;
        box-sizing: border-box;
        border-radius: 8px;
        position: relative;
        display: flex;
        border: 1px solid #E7E7E7;
        flex-direction: column;
        .img-span {
          position: absolute;
        }
        .svg-icon {
          font-size: 30px;
          margin-bottom: 24px;
        }
        .contentCreate-tips {
          font-size: 12px;
          color: #ccd1d6;
          font-weight: 400;
        }
        &.show-back {
          // background: url(../../../assets/analysis/bg.png) center;
          background-size: cover!important;
        }

        .contentList-text {
          margin-top: 77px;

          .title {
            font-size: 12px;
            font-family: PingFang SC-中黑体, PingFang SC;
            font-weight: normal;
            color: #7D6955;
            line-height: 16px;
            -webkit-line-clamp: 3; /* 可以显示的行数，超出部分用...表示*/
            -webkit-box-orient: vertical;
          }
        }
      }
      .content {
        margin-left: 40px;
        position: relative;
        width: 100%;
        .mg12 {
          margin-bottom: 12px;
        }
        .bottom-info-item {
          margin-right: 15px;
        }
        .content-title {
          font-size: 18px;
          font-family: PingFang SC-中黑体, PingFang SC;
          font-weight: 600;
          color: #1A173B;
          line-height: 14px;
          display: flex;
          align-items: center;
          cursor: pointer;
          justify-content: space-between;
          .img-svg {
            margin-left: 10px;
            vertical-align: text-bottom;
          }
        }
        .content-tag {
          font-size: 10px;
          font-family: PingFang SC-常规体, PingFang SC;
          font-weight: normal;
          line-height: 18px;
          span {
            background: rgba(222,222,222,0.7000);
            border-radius: 4px 4px 4px 4px;
            color: #868686;
            padding: 2px 10px;
            margin-right: 5px;
          }
          span.trade {
            background: rgba(234,85,25,0.1020);
            color: $--color-theme;
          }
          span.country {
            background: rgba(246,171,0,0.1020);
            color: #B0831D;
          }
          span.company {
            background: rgba(104,174,75,0.1020);
            color: #598C43
          }
          span.trend {
            background: rgba(209,134,181,0.1000);
            color: #A5688E;
          }
          span.brand {
            background: rgba(14,153,235,0.1020);
            color: #4785AA
          }
        }
        .content-text {
          font-size: 14px;
          font-family: PingFang SC-中黑体, PingFang SC;
          font-weight: normal;
          color: #666666;
          line-height: 24px;
        }
      }
    }
    .img-svg {
      font-size: 50px !important;
      height: 0.5em;
    }
  }
}
</style>
